// @flow @jsx h
import { h, Component } from 'preact'
import styles from './App.css'
import { connect } from '../../../lib/provider'
import MapStory from './MapStory'

import type { SectionType } from '../../domain'

type Props = {
  card: string,
  sendGaEvent: (Object) => void,
  contextId: string,
  doc: {
    sections: SectionType[]
  }
}

type AppState = {
  viewport: { height: number, width: number }
}

class _App extends Component<Props, AppState> {
  logoElement: HTMLElement

  constructor () {
    super()
    this.state = {
      viewport: { height: -1, width: -1 }
    }
  }

  handleViewportChange = (viewport: any) => {
    if (
      this.state.viewport.height !== viewport.height ||
      this.state.viewport.width !== viewport.width
    ) {
      this.setState({ viewport })
    }
  }

  render () {
    const { doc, card } = this.props
    const initialCard = card ? parseInt(card) : 0
    return (
      <aside class={styles.app + ' nrk-aspect nrk-aspect--1x1'}>
        <h2 class='nrk-sr'>Tidslinje</h2>
        <MapStory
          initialCard={initialCard}
          sections={doc.sections} overlays={[]} labels={[]} viewport={this.state.viewport}
          sendGaEvent={this.props.sendGaEvent} />
      </aside>
    )
  }
}

const connector = connect()
// const connector = connect(mapContextToProps)
export const App = connector(_App)
